import { Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Index from "./pages";
import AboutUs from "./pages/aboutus";
import Blog from "./pages/blogs";
import BlogDetails from "./pages/blog-detail";
import EventDetail from "./pages/event-detail";
import ContactUs from "./pages/contacto";
import Pay from "./pages/sidom-pay";
import Isurance from "./pages/sidom-insurance";
import Misim from "./pages/sidom-misim";
import SmartReader from "./pages/sidom-smart-reader";
import Eventos from "./pages/sidom-eventos";
import AccesoAcliente from "./pages/sidom-acceso-cliente";
import Mre from "./pages/sidom-mre";
import Ejemplo1 from "./components/ejemplo1";
import Ejemplo2 from "./pages/ejemplo2";
import Ejemplo3 from "./pages/ejemplo3";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import PrivateRoute from "./components/PrivateRoute";
import MetaPixel from "./components/MetaPixel";
import GoogleAnalytics from "./components/GoogleAnalytics";
import GoogleAds from "./components/GoogleAds";
import Landing from "./pages/landing";

import { useConsentStore } from "./store/useConsentStore";

function App() {
  const location = useLocation();
  const setConsent = useConsentStore((s) => s.setConsent);
  useEffect(() => {
    const saved = localStorage.getItem("cookieConsent");
    if (saved) {
      try {
        setConsent(JSON.parse(saved));
      } catch (e) {}
    }
  }, []);
  useEffect(() => {
    AOS.init({ duration: 800, once: false });
  }, []);
  useEffect(() => {
    AOS.refresh();
  }, [location]);
  return (
    <div className="App">
      {/** Tracking --> */}
      <MetaPixel />
      <GoogleAnalytics />
      <GoogleAds />
      {/** Tracking */}
      <Routes>
        <Route path="/" element={<Index />} />
        {/** rutas sidom */}
        <Route path="/about" element={<AboutUs />} />
        <Route path="/blogs" element={<Blog />} />
        <Route path="/blog-detail" element={<BlogDetails />} />
        <Route path="/blog-detail/:id" element={<BlogDetails />} />
        <Route path="/event-detail/:id" element={<EventDetail />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/pay" element={<Pay />} />
        <Route path="/sidom-insurance" element={<Isurance />} />
        <Route path="/sidom-misim" element={<Misim />} />
        <Route path="/sidom-smart-reader" element={<SmartReader />} />
        <Route path="/sidom-eventos" element={<Eventos />} />
        <Route path="/sidom-acceso-clientes" element={<AccesoAcliente />} />
        <Route path="/sidom-mre" element={<Mre />} />
        <Route path="/ejemplo1" element={<Ejemplo1 />} />
        <Route path="/ejemplo2" element={<Ejemplo2 />} />
        <Route path="/ejemplo3" element={<Ejemplo3 />} />
        <Route path="/politicas-de-privacidad" element={<PrivacyPolicy />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route path="/landing/:slug" element={<Landing />} />

        {/** -----------------------------------------------*/}
      </Routes>
    </div>
  );
}

export default App;
